import React from "react";
import { AllSelectedFilterInfo, FilterClickHandler } from "web/types/feed-filters";
import { useSelector as useReduxSelector } from "react-redux";
import BreadcrumbPills from "web/react/components/feeds-filters/feeds-filter-breadcrumb-pills/feeds-filter-breadcrumb-pills";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { openFeedsFiltersOverlay } from "web/react/components/feeds-filters/hooks/use-overlay-handler";
import { ReduxStoreState } from "web/redux/store";
import { FeedSidebarSlice } from "web/redux/ducks/feed-sidebar";
import { gettext } from "web/script/modules/django-i18n";
import styles from "./feeds-filter-bar.css";

interface FeedsFilterBarProps {
    selectedFilterInfo: AllSelectedFilterInfo;
    onClick: FilterClickHandler;
}

function extractControlState(state: ReduxStoreState): FeedSidebarSlice {
    return state.feedSidebarReducer;
}

function FeedsFilterBar({ onClick, selectedFilterInfo }: FeedsFilterBarProps): null | JSX.Element {
    const { loading } = useReduxSelector(extractControlState);

    function onClickFilters(): void {
        openFeedsFiltersOverlay();
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.scrollableWrapper}>
                <BreadcrumbPills
                    selectedFilterInfo={selectedFilterInfo}
                    onClick={(option): void =>
                        onClick({ ...option, event_prefix: "filter_mobile" }, true, true)
                    }
                    className={styles.pills}
                />
            </div>
            <span role="presentation" className={styles.divider} />
            <button
                className={styles.filterButton}
                onClick={onClickFilters}
                disabled={loading}
                aria-label={gettext("feed.filter.mobile_btn_text")}
            >
                <SVGIcon name="filters" className={styles.svgIcon} />
            </button>
        </div>
    );
}

export default FeedsFilterBar;
